import gql from 'graphql-tag';

const UPDATE_ORDER_COMMENT = gql`
  mutation updateComment($comment: String!) {
    updateComment(comment: $comment)
  }
`;

export {UPDATE_ORDER_COMMENT};
